import { render, staticRenderFns } from "./TablePageV2.vue?vue&type=template&id=60b2a8bc&scoped=true&"
import script from "./TablePageV2.vue?vue&type=script&lang=js&"
export * from "./TablePageV2.vue?vue&type=script&lang=js&"
import style0 from "./TablePageV2.vue?vue&type=style&index=0&id=60b2a8bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b2a8bc",
  null
  
)

export default component.exports